import { isObjectRecord } from "../../typeGuards";
import { ArsTableHeaderRow } from "../interface";
import { isArsTableHeaderCell } from "./isArsTableHeaderCell";

/**
 * Type guard for ArsTableHeaderRow, which is a specific type of ArsTableRow that represents a header row in the table.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cells' displayContent and annotationContent
 * @returns - True if the object is an ArsTableHeaderRow, false otherwise
 */
export const isArsTableHeaderRow = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableHeaderRow<T> => {
  // Check object
  if (!isObjectRecord(obj)) return false;

  // Check required properties
  if (typeof obj.height !== "number") return false;
  if (
    !Array.isArray(obj.arsTableCells) ||
    obj.arsTableCells.some((cell) => !isArsTableHeaderCell(cell, isT))
  )
    return false;

  // Everything is good
  return true;
};
